export default "__VITE_ASSET__GQebMQfK__"